import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import ApartmentNameChip from '../ApartmentNameChip';

function Tag({ addAllOptionsId, getTagProps, hasAddAllOptions, newItemId, tagValue }) {
  return tagValue.map((option, index) => {
    const { key, ...tagProps } = getTagProps({ index });
    if (option.id === newItemId || (hasAddAllOptions && option.id === addAllOptionsId)) {
      return <Chip color="primary" key={key} label={option.label || ''} {...tagProps} />;
    }
    return <ApartmentNameChip key={key} name={option.name} number={option.number} size="default" {...tagProps} />;
  });
}

Tag.propTypes = {
  addAllOptionsId: PropTypes.string,
  getTagProps: PropTypes.func.isRequired,
  hasAddAllOptions: PropTypes.bool,
  newItemId: PropTypes.string.isRequired,
  tagValue: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default Tag;
